import { HERO_TRUST_ITEMS } from '../constants';
import * as styled from '../styles/hero-trust-row';
import { HeroCheckIcon } from './hero-check-icon';

export const HeroTrustRow = () => (
  <styled.Row>
    {HERO_TRUST_ITEMS.map((label) => (
      <styled.Item key={label}>
        <HeroCheckIcon />
        {label}
      </styled.Item>
    ))}
  </styled.Row>
);
